import { render, staticRenderFns } from "./ultimTab.vue?vue&type=template&id=633675ef&scoped=true&"
import script from "./ultimTab.vue?vue&type=script&lang=js&"
export * from "./ultimTab.vue?vue&type=script&lang=js&"
import style0 from "./ultimTab.vue?vue&type=style&index=0&id=633675ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633675ef",
  null
  
)

export default component.exports